// extracted by mini-css-extract-plugin
module.exports = {"btnWrapper":"_2ZjdvZh5EmCxmFKDRKaqJD","cancelBtn":"_3qBqNnXaG2D-kFh4gluePc","icon":"_3Wgjf3xLeZXaEea_NqXRLc","saveBtn":"_1pyM0x7E1Zph32aICbzFqp"};